import { createRouter, createWebHistory } from 'vue-router';

import { ROUTES } from '@/consts/routes.const';

import { keepNavigationGuardParams, noDataNavigationGuard } from './navigationGuards';

const Home = async () => import(/* webpackChunkName: "home" */ '../views/Home.vue');
const ConfirmBooking = async () => import(/* webpackChunkName: "confirm" */ '@components/steps/ConfirmBooking/ConfirmBooking.vue');
const WelcomeView = async () => import(/* webpackChunkName: "welcome" */ '@components/steps/WelcomeView/WelcomeView.vue');
const BookingNotFound = async () => import(/* webpackChunkName: "bookingNotFound" */ '@components/steps/BookingNotFound/BookingNotFound.vue');
const MissingAutofillData = async () => import(/* webpackChunkName: "MissingAutofillData" */ '@components/steps/MissingAutofillData/MissingAutofillData.vue');
const ValidateBooking = async () => import(/* webpackChunkName: "validateBooking"*/ '@components/steps/ValidateBooking/ValidateBooking.vue');
const SelectCountry = async () => import(/* webpackChunkName: "selectCountry"*/ '@components/steps/SelectCountry/SelectCountry.vue');
const ValidateDocuments = async () => import(/* webpackChunkName: "validateDocuments"*/ '@components/steps/ValidateDocuments/ValidateDocuments.vue');
const UpdateAddress = async () => import(/* webpackChunkName: "updateAddress"*/ '@components/steps/UpdateAddress/UpdateAddress.vue');
const StepsSummary = async () => import(/* webpackChunkName: "stepsSummmary"*/ '@components/steps/StepsSummary/StepsSummary.vue');

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: ROUTES.BASE.path,
      component: Home,
      redirect: { name: ROUTES.WELCOME.name },
      children: [
        {
          path: ROUTES.VALIDATE_BOOKING.path,
          name: ROUTES.VALIDATE_BOOKING.name,
          component: ValidateBooking,
        },
        {
          path: ROUTES.CONFIRM_BOOKING.path,
          name: ROUTES.CONFIRM_BOOKING.name,
          component: ConfirmBooking,
        },
        {
          path: ROUTES.WELCOME.path,
          name: ROUTES.WELCOME.name,
          component: WelcomeView,
        },
        {
          path: ROUTES.BOOKING_NOT_FOUND.path,
          name: ROUTES.BOOKING_NOT_FOUND.name,
          component: BookingNotFound,
        },
        {
          path: ':brokerId/:token',
          redirect: (to) => {
            return { name: ROUTES.WELCOME.name, query: { ...to.params, ...to.query } };
          },
        },
        {
          path: ROUTES.SELECT_COUNTRY.path,
          name: ROUTES.SELECT_COUNTRY.name,
          component: SelectCountry,
        },
        {
          path: ROUTES.VALIDATE_DOCUMENTS.path,
          name: ROUTES.VALIDATE_DOCUMENTS.name,
          component: ValidateDocuments,
        },
        {
          path: ROUTES.UPDATE_ADDRESS.path,
          name: ROUTES.UPDATE_ADDRESS.name,
          component: UpdateAddress,
        },
        {
          path: `${ROUTES.REQUIRED_CLIENT_DATA.path}/:brokerId/:token`,
          name: ROUTES.REQUIRED_CLIENT_DATA.name,
          component: MissingAutofillData,
        },
        {
          path: ROUTES.SUMMARY.path,
          name: ROUTES.SUMMARY.name,
          component: StepsSummary,
        },
      ],
    },
    { path: '/', redirect: `${ROUTES.BASE.path}/${ROUTES.WELCOME.path}` },
  ],
});
router.beforeEach(keepNavigationGuardParams);
router.beforeEach(noDataNavigationGuard);

export default router;
